import { Box, Typography } from '@mui/material'
import React from 'react'

import WorldBasePage from './WorldBasePage'

const Web3DebugPage: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const global = window as any

  return (
    <WorldBasePage>
      <Box alignItems="center" display="flex" flexDirection="column" flexGrow={1} justifyContent="center" width="100vw">
        <Typography align="center" variant="h2">
          Web3 Debugger
        </Typography>
        <Typography align="center" variant="body1">{`Provider Name: ${global.ethereum?.providerName}`}</Typography>
        <Typography align="center" variant="body1">{`IsTrust: ${global.ethereum?.isTrust ?? false}`}</Typography>
        <Typography align="center" variant="body1">{`IsOpera: ${global.ethereum?.providerName === 'opera'}`}</Typography>
        <Typography align="center" variant="body1">{`IsMetaMask: ${global.ethereum?.isMetaMask ?? false}`}</Typography>
        <Typography align="center" variant="body1">{`Web3 Object: ${typeof global.web3}`}</Typography>
        <Typography align="center" variant="body1">{`Web3 Current Provider: ${typeof global.web3?.currentProvider}`}</Typography>
        <Typography align="center" variant="body1">{`Ethereum Object: ${typeof global.ethereum}`}</Typography>
        <Typography align="center" variant="body1">{`Ethereum On: ${typeof global.ethereum?.on}`}</Typography>
        <Typography variant="h3">Ethereum</Typography>
      </Box>
    </WorldBasePage>
  )
}

export default Web3DebugPage
